import css from './EventInfo.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { IEventDetails } from 'meta/backendControlled/structure'
import DataTestId from 'meta/dataTestId'
import { Dates } from 'utils/dates'

import Img from 'components/Media/Img'
import { useUrlCloudfront } from 'hooks/useEnv'

interface IPropsEventDetails {
  event: IEventDetails
}

const EventInfo: React.FC<IPropsEventDetails> = (props) => {
  const { event } = props
  const { coverImg, datetime, location, name } = event

  const { t } = useTranslation()

  const urlCloudfront = useUrlCloudfront()

  const imageUrl = coverImg || `${urlCloudfront}/images/carousel/placeholders/square_cover_ticketsms_placeholder.svg`
  const date = Dates.format(new Date(datetime), t('dates:common:longDate'))
  const time = Dates.format(new Date(datetime), 'H:mm')

  return (
    <div className={css.eventInfo}>
      <img alt={event.name} className={classNames(css.eventImg, { [css.withBorder]: !coverImg })} src={imageUrl} />

      <div className={css.eventDesc}>
        <div className={css.eventDate}>
          <strong>{date}</strong>
          {` / ${time}`}
        </div>

        <h2 data-testid={DataTestId.purchaseForm.eventName} className={css.eventName}>
          {name}
        </h2>

        <div className={css.eventLocation}>
          <Img src="/icons/location_marker.svg" />
          <div>{`${location?.name} / ${location?.common}`}</div>
        </div>
      </div>
    </div>
  )
}

export default EventInfo
